import SrSearch from "./index.vue";

SrSearch.install = function(Vue) {
  Vue.component(SrSearch.name, SrSearch);
};

export default SrSearch;



// WEBPACK FOOTER //
// ./packages/SrSearch/index.js